import { Pipe, PipeTransform } from '@angular/core';
import {Booking} from '../model/booking.entity';
import * as momentTimeZone from 'moment-timezone';

@Pipe({
  name: 'momentTZDate'
})
export class MomentTZDatePipe implements PipeTransform {
  transform(timeVal: any, state: any, postCode: any): any {
    let res = '';
    if (timeVal && state && postCode) {
      let timeZone = Booking.getNamedTimeZone(state, postCode.toString());
      res = momentTimeZone(timeVal).tz(timeZone).format('ddd MMM Do YY');
    }
    return res.length ? res : timeVal ? timeVal : '';
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipe/moment-tzdate.pipe.ts